export default "__VITE_ASSET__C808u2ud__"